export const DISPLAY_TYPES = {
    TEXT: 'Text',
    TEXT_BOX: 'TextBox',
    CHECKBOX: 'CheckBox',
    DROPDOWN: 'Select',
}

export const VALIDATION_TYPES = {
    INT: 'int',
    FLOAT: 'float',
    PATH: 'path',
}